import httpClient from "../helpers/httpClient";

export const getCategories = (params: any) => {
    return httpClient.get("/api/v3/categories", { params });
};

export const getCategoryById = (id: number | string) => {
    return httpClient.get("/api/v3/categories/" + id);
};
